import { useEffect } from 'react'

export function useActiveSection(ids: string[], onActive: (id: string) => void) {
  useEffect(() => {
    const elements = ids.map((id) => document.getElementById(id)).filter((element): element is HTMLElement => Boolean(element))
    if (!elements.length) return

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]
        if (visible?.target.id) onActive(visible.target.id)
      },
      { rootMargin: '-22% 0px -55% 0px', threshold: [0.05, 0.2, 0.45] },
    )

    elements.forEach((element) => observer.observe(element))
    return () => observer.disconnect()
  }, [ids, onActive])
}
